module.exports = __webpack_public_path__ + "static/header-466cb1f10fc3d1a32ac907fe524255bf.jpg";